export class TmpQrcodeGroupTranslator {
  /**
   * 登録処理用ペイロード作成
   * @param {*} item アイテム
   */
  static toCreatePayload(item) {
    return {
      tmpqr_grp_name: item.tmpqr_grp_name, // 仮QRコード発行単位名
      issues_num: item.issues_num // 発行件数
    };
  }
  /**
   * 更新処理用ペイロード作成
   * @param {*} item アイテム
   * @param {*} deleteFlg 1:削除、1以外：更新
   */
  static toUpdatePayload(item, deleteFlg = "0") {
    return {
      tmpqr_grp_id: item.tmpqr_grp_id, // 仮QRコード発行単位
      tmpqr_grp_name: item.tmpqr_grp_name, // 仮QRコード発行単位名
      delete_flg: deleteFlg, // 論理削除フラグ（1:削除、1以外：更新）
      hash: item.hash // ハッシュ値
    };
  }
  /**
   * 削除処理用ペイロード作成
   * @param {*} item アイテム
   */
  static toDeletePayload(item) {
    return this.toUpdatePayload(item, "1");
  }
}
